// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal_confirmation_header_no_close-module__title--17j0T{color:#303030;font-weight:700;font-size:21px;line-height:30px;letter-spacing:.2px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,sans-serif;padding:24px}\n", ""]);
// Exports
exports.locals = {
	"title": "modal_confirmation_header_no_close-module__title--17j0T"
};
module.exports = exports;
